/* eslint-disable */
import BASE from '../../../../vue.config.js'
const $ = require('jquery')
window.$ = $

export default {
  data: () => ({
    
    validador: true, 
    jerarquias:[],
    modulos: [],
    permisos: [],

    idJerarquia:'',
    nombre:'',
    descripcion:'',
    jerarquiaValidacion:'',
    NombreValidacion:'',
    PermisosValidacion:'',
    idRol:'',
    idModulo:0,
    guardar:'',
    editar:'',
    consultar:'',
    eliminar:'',
    cambiarEstatus:'',
    permisoExtra:'',
    objetoSubModulos:[],
    contenedor:[],
    objeto:{},
    moduloPermiso:[],
    counterDanger:true,
    isButtonDisabled:false,
    nombrePermiso:'N/A',
    mostarPermisoExtra:0,
    deshabilitarPermisoGuardar:0,
    deshabilitarPermisoEditar:0,
    deshabilitarPermisoActivar:0,
    deshabilitarPermisoEliminar:0,
    deshabilitarPermisoConsultar:0,
    color:''
    
  }),

  methods: {
    Guardar(){
      if (this.idRol == 0){
        this.GuardarRol();
      }else{ 
        this.Editar();
      }
    },
   
    ObtenerInformacion(){
      fetch(`${BASE.baseUrl}api/FormularioRoles`, {
        method: 'GET',
        headers: {
          'Authorization' :sessionStorage.getItem('token')
        }
      })
      .then(rs => rs.json())
      .catch(error => console.log('error:', error))
      .then(rs => {
        if(rs.status == 200){
          rs.result.jerarquias.forEach((item, index) => {
            this.jerarquias.push({  text: item.nombre, value: item.id, isSelected: false });
          });
          this.permisos = rs.result.permisos;

          rs.result.modulos.forEach((item, index) => {
              item.submodulos.forEach((itemS, indexS) => {
                  this.objetoSubModulos.push(itemS);
              });
          });
          this.modulos = rs.result.modulos;
        }
      });
    },

    ModulosExtra(id){
      switch(id){

        case 13: //PLANTELES
          this.nombrePermiso = 'Asignar Ofertas';
          this.mostarPermisoExtra = 1;
          break;
        case 7: //PROFESORES
          this.nombrePermiso = 'Asignar Materias';
          this.mostarPermisoExtra = 1;
          break;
        case 10: //ALUMNOS
          this.nombrePermiso = 'Inscripción';
          this.mostarPermisoExtra = 1;
          break;
        case 59: //GRUPOS
          this.nombrePermiso = 'Detalle Grupo';
          this.mostarPermisoExtra = 1;
          break;
        case 33: //MODALIDADES
          this.nombrePermiso = 'Detalle Modalidad';
          this.mostarPermisoExtra = 1;
          break;
        default:
          this.nombrePermiso = 'N/A';
          this.mostarPermisoExtra = 0;
          break;
      }
    },

    ModulosSinPermsisos(id){
  
     switch(id){
         case 59: //GRUPOS ADMINISTRADOR
          this.deshabilitarPermisoEditar    = 1; 
          this.deshabilitarPermisoEliminar  = 1; 
          this.deshabilitarPermisoConsultar = 1; 
          break;  

          case 62: //MIS GRUPOS PROFESOR
          this.deshabilitarPermisoGuardar   = 1; 
          this.deshabilitarPermisoEditar    = 1; 
          this.deshabilitarPermisoActivar   = 1; 
          this.deshabilitarPermisoEliminar  = 1; 
          
          case 64: //MATERIAS PROFESOR
          this.deshabilitarPermisoGuardar   = 1; 
          this.deshabilitarPermisoEditar    = 1; 
          this.deshabilitarPermisoActivar   = 1; 
          this.deshabilitarPermisoEliminar  = 1; 
          break;

          case 66: //ASIGNAR TAREAS PROFESOR
          this.deshabilitarPermisoActivar   = 1; 
          this.deshabilitarPermisoConsultar = 1; 
          this.deshabilitarPermisoEliminar  = 1; 
          break;

          case 55: // TAREAS ALUMNOS
          this.deshabilitarPermisoGuardar   = 1; 
          this.deshabilitarPermisoEditar    = 1; 
          this.deshabilitarPermisoActivar   = 1; 
          this.deshabilitarPermisoEliminar  = 1; 
          break;

          case 51: // INSCRIPCIONES ALUMNOS
          this.deshabilitarPermisoGuardar   = 1; 
          this.deshabilitarPermisoEditar    = 1; 
          this.deshabilitarPermisoActivar   = 1; 
          this.deshabilitarPermisoEliminar  = 1; 
          break;

          case 57: // PAGOS ALUMNOS
          this.deshabilitarPermisoGuardar   = 1; 
          this.deshabilitarPermisoEditar    = 1; 
          this.deshabilitarPermisoActivar   = 1; 
          this.deshabilitarPermisoEliminar  = 1; 
          break;
          case 87:  //dev 90: //VALIDACION DE PAGOS 76
          this.deshabilitarPermisoGuardar   = 1; 
          this.deshabilitarPermisoEditar    = 1; 
          this.deshabilitarPermisoActivar   = 1; 
          this.deshabilitarPermisoEliminar  = 0; 
          this.deshabilitarPermisoConsultar = 0; 
          break;

          case 89: //dev 92: //VALIDACION DE PAGOS 76
          this.deshabilitarPermisoGuardar   = 1; 
          this.deshabilitarPermisoEditar    = 1; 
          this.deshabilitarPermisoActivar   = 1; 
          this.deshabilitarPermisoEliminar  = 1; 
          this.deshabilitarPermisoConsultar = 0; 
          break;

        default:
          this.deshabilitarPermisoGuardar   = 0; 
          this.deshabilitarPermisoEditar    = 0; 
          this.deshabilitarPermisoActivar   = 0; 
          this.deshabilitarPermisoEliminar  = 0; 
          this.deshabilitarPermisoConsultar = 0; 

          break;
      }
    },

    SelccionarElementos(id){
      this.idModulo = id
      this.guardar =''
      this.editar = ''
      this.cambiarEstatus =''
      this.eliminar =''
      this.consultar =''
      this.permisoExtra = ''
      var insertar = true

      this.deshabilitarPermisoGuardar   = 0; 
      this.deshabilitarPermisoEditar    = 0; 
      this.deshabilitarPermisoActivar   = 0; 
      this.deshabilitarPermisoEliminar  = 0; 
      this.deshabilitarPermisoConsultar = 0; 

      this.ModulosExtra(this.idModulo);
      this.ModulosSinPermsisos(this.idModulo);

      if(this.contenedor.length == 0){
             this.objeto = new Object();
             this.objeto.idModulo = id;
             this.objeto.permisos = [];
      }      

      this.contenedor.forEach((item, index) => {
         if (id == item.idModulo){
        
          item.permisos.forEach((itemP, indexP) => {
              if (itemP == 1){ this.guardar ='checked'; };
              if (itemP == 2){ this.editar ='checked'; };
              if (itemP == 3){ this.cambiarEstatus ='checked'; };
              if (itemP == 4){ this.eliminar ='checked'; };
              if (itemP == 5){ this.consultar ='checked'; };
              if (itemP == 6){ this.permisoExtra ='checked'; };
            });
          insertar = false;
        }else{
            this.objeto = new Object();
            this.objeto.idModulo = id;
            this.objeto.permisos = [];
        }
      });
      if (insertar == true){this.contenedor.push(this.objeto);}
            
      $('li').removeClass('imh-li-active');
      $('li a').removeClass('imh-a-active');

      $('#'+ id).addClass('imh-li-active');
      $('#a_'+ id).addClass('imh-a-active');
      
      $('div .vs-collapse-item').removeClass('open-item');
      $('div .vs-collapse-item--content').css('max-height','0');

    },

    SeleccionarPermiso(idPermiso){
      var continuar = true;
      this.contenedor.forEach((item, index) => {
        if (this.idModulo == item.idModulo){
            item.permisos.forEach((itemP, indexP) => {
            if(idPermiso == itemP){
                var i = item.permisos.indexOf(idPermiso);
                item.permisos.splice(i,1);
                continuar = false;
               
                  //ELIMINAMOS DEL ARREGLO DE this.moduloPermiso
                   this.objetoSubModulos.forEach((itemS, indexS) => {
                    if(this.idModulo == itemS.idModuloPrincipal){
                        itemS.permisos.forEach((itemPF, indexPF) => {
                            if(itemPF.idPermiso == idPermiso){
                               var ii = this.moduloPermiso.indexOf(itemPF.idDetalleModuloPermiso);
                                  this.moduloPermiso.splice(ii,1);
                            }
                        });
                    } 
                  });
            }
          });
          if (continuar == true)  { 
        
            this.objetoSubModulos.forEach((itemS, indexS) => {
                if(this.idModulo == itemS.idModuloPrincipal){
                  itemS.permisos.forEach((itemPF, indexPF) => {
                      if(itemPF.idPermiso == idPermiso){
                        this.moduloPermiso.push(itemPF.idDetalleModuloPermiso);
                      }
                  });
                }
            });
            item.permisos.push(idPermiso);
          }
        }
      });
    },
 
    GuardarRol(){

     var objeto = this.ObtenerValoresObjeto();
     if (JSON.stringify(objeto) !='{}') {
      this.openLoadingButton();
        fetch(`${BASE.baseUrl}api/AgregarRol`, {
        method: 'POST',
            headers: {
              'Authorization': sessionStorage.getItem('token'),
              'pagina':'roles',
              'Content-Type':'application/json'
            },
            body: JSON.stringify(objeto),
        })
        .then(rs => rs.json())
        .catch(error => console.log('error:', error))
        .then(rs => {
          this.MostrarMensaje(rs.status);
        })
      }
    },

    Editar(){
      var objeto = this.ObtenerValoresObjeto();

      if (JSON.stringify(objeto) !='{}') {
        this.openLoadingButton();
        fetch(`${BASE.baseUrl}api/EditarRol`, {
        method: 'POST',
            headers: {
              'Authorization': sessionStorage.getItem('token'),
              'pagina':'roles',
              'Content-Type':'application/json'
            },
            body: JSON.stringify(objeto),
        })
        .then(rs => rs.json())
        .catch(error => console.log('error:', error))
        .then(rs => {
          this.MostrarMensaje(rs.status);
        })
      }
    },

    ObtenerRol(idRol){

      fetch(`${BASE.baseUrl}api/ObtenerRol/${idRol}`, {
            method: 'GET',
            headers: {
              'Authorization': sessionStorage.getItem('token'),
              'pagina':'roles'
            }
        })
          .then(rs => rs.json())
          .catch(error => console.log('error:', error))
          .then(rs => {
            if(rs.status == 200){

              this.idJerarquia = rs.result.idJerarquia;
              this.nombre = rs.result.nombre;
              this.descripcion = rs.result.descripcion;
              this.contenedor = rs.result.cadenaModuloPermiso;
              this.moduloPermiso = rs.result.detalleModulo;
               setTimeout(() => { this.OcultarMenu(rs.result.idJerarquia); },1000); 
            }
             
          });
    },
      //MUESTRA EN MENSAJE DE LA RESUESTA
    MostrarMensaje(idResupesta){
    
      switch(idResupesta){
        case 200:
          this.$vs.notify({color:'success',title:'Exitoso',text:'El registro se ha guardado correctamente.'})
          this.$router.push('/roles') ; 
          break;
        case 207:
          this.$vs.notify({color:'warning',title:'Alerta',text:'El rol que se quiere registrar ya existe.'})
          break;
        case 427:
          this.$vs.notify({color:'warning',title:'Alerta',text:'No tiene permisos para esta acción.'})
          break;
        case 429:
          this.$vs.notify({color:'warning',title:'Alerta',text:'Datos incorrectos'})
          break;
        case 500:
          this.$vs.notify({color:'danger',title:'Error',text:'Ha ocurrido un error. Favor de ponerse en contacto con el administrador.'})
          break;
        default:
          this.$vs.notify({color:'warning',title:'Alerta',text:'Favor de ponerse en contacto con el administrador.'})
          break;
      }
    },
    
    //OBTENMOS LOS VALORES DEL FORMULARIO (SE USA PARA GUARDA Y EDITAR)
    ObtenerValoresObjeto(){
     
      this.ValidarValores();
      var objeto = {};

      if (this.validador == true){
        objeto = {
          'idRol': this.idRol,
          'idJerarquia':this.idJerarquia,
          'nombre':this.nombre,
          'descripcion':this.descripcion,
          'cadenaModuloPermiso': this.moduloPermiso
        }
      }
      return objeto 
    },

    openLoadingButton(){
      this.isButtonDisabled = true;
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#save-button',
        scale: 0.45
      })
      setTimeout(()=>{
        this.$vs.loading.close('#save-button > .con-vs-loading');
        this.isButtonDisabled = false;
      }, 2000)
    },

    ValidarValores(){
      if (this.idJerarquia == ''){ this.validador = false; this.jerarquiaValidacion = 'El campo Jerarquia es obligatorio.'}
      if (this.nombre == ''){ this.validador = false; this.NombreValidacion = 'El campo Nombre es obligatorio.' }
      if (this.moduloPermiso.length == 0) {this.validador = false; this.PermisosValidacion = 'Debes seleccionar por lo menos un permiso.'}
    },

    OcultarMenu(valor){
    
      switch(valor){

        case 1:
            $('#51').hide();$('#55').hide();$('#57').hide();
            $('#62').hide();$('#64').hide();$('#66').hide();

            $('#1').show();$('#4').show();$('#7').show();$('#10').show();$('#13').show();
            $('#59').show();$('#33').show();$('#36').show();$('#39').show();$('#45').show();
            $('#48').show();$('#20').show();$('#23').show();$('#26').show();$('#29').show();
            $('#73').show();$('#42').show();$('#76').show()

        break;
        case 2:
            $('#62').show();$('#64').show();$('#66').show();
            $('#51').hide();$('#55').hide();$('#57').hide();

            $('#1').hide();$('#4').hide();$('#7').hide();$('#10').hide();$('#13').hide();
            $('#59').hide();$('#33').hide();$('#36').hide();$('#39').hide();$('#45').hide();
            $('#48').hide();$('#20').hide();$('#23').hide();$('#26').hide();$('#29').hide();
            $('#73').hide();$('#42').hide();$('#76').hide()
        break;

        case 3:
            $('#62').hide();$('#64').hide();$('#66').hide();
            $('#51').show();$('#55').show();$('#57').show();

            $('#1').hide();$('#4').hide();$('#7').hide();$('#10').hide();$('#13').hide();
            $('#59').hide();$('#33').hide();$('#36').hide();$('#39').hide();$('#45').hide();
            $('#48').hide();$('#20').hide();$('#23').hide();$('#26').hide();$('#29').hide();
            $('#73').hide();$('#42').hide();$('#76').hide()
        break;
      }

    },
  },
  
    
 watch: { 
    'idJerarquia': function(valor) { 
        this.OcultarMenu(valor);
    },
    
  },
  mounted(){
      this.ObtenerInformacion();
  },
   created() {

    
      this.idRol = this.$route.params.idRol;
      if (this.idRol !=0){ this.ObtenerRol(this.idRol);}


    },
  updated(){
    if (this.idJerarquia != ''){ this.jerarquiaValidacion = '';  this.validador = true; }
    if (this.nombre != ''){ this.NombreValidacion = ''; this.validador = true; }
    if (this.moduloPermiso.length > 0) { this.PermisosValidacion = ''; this.validador = true;}
  }
}
